// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTestTube2 as RawLucideTestTube2 } from "lucide-react";
export const LucideTestTube2 = /* @__PURE__ */ createIcon(RawLucideTestTube2, "LucideTestTube2", 2);
